import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import Pipeline from 'types/pipeline';
import APIError from 'types/api_error';
import { PipelineTemplateSummary } from 'types/pipeline_template';

import { useCreatePipeline } from 'pipelines/hooks/useCreatePipeline';
import { useReadPipelineTemplate } from 'pipelines/hooks/usePipelineTemplate';

type UseCreatePipelineFromTemplateParams = {
  template: PipelineTemplateSummary;
  name?: string;
};

export function useCreatePipelineFromTemplate(
  options: UseMutationOptions<
    Pipeline,
    APIError,
    UseCreatePipelineFromTemplateParams
  > = {}
) {
  const readPipelineTemplate = useReadPipelineTemplate();
  const { mutateAsync: createPipeline } = useCreatePipeline();

  return useMutation(async ({ template, name }) => {
    const pipelineTemplate = await readPipelineTemplate(template.id);

    return createPipeline({
      name: name ?? getPipelineNameFromTemplate(template.name),
      definition: pipelineTemplate.definition,
    });
  }, options);
}

function getPipelineNameFromTemplate(templateName: string) {
  return `${templateName} - ${crypto.randomUUID().substring(0, 5)}`;
}
